import { ambientFloatLoopSkill } from './ambientFloatLoop';
import { ambientParticleFieldSkill } from './ambientParticleField';
import { anchoredRelayRevealSkill } from './anchoredRelayReveal';
import { atmosphereGradientFieldSkill } from './atmosphereGradientField';
import { beatSyncAccentSkill } from './beatSyncAccent';
import { calloutWithLeaderLineSkill } from './calloutWithLeaderLine';
import { cardGridAssembleSkill } from './cardGridAssemble';
import { chartStoryBuildSkill } from './chartStoryBuild';
import { cinematicCameraMoveSkill } from './cinematicCameraMove';
import { cornerBadgeStackSkill } from './cornerBadgeStack';
import { counterTickUpSkill } from './counterTickUp';
import { dataAsMetaphorSkill } from './dataAsMetaphor';
import { deviceScreenDiveSkill } from './deviceScreenDive';
import { driftAndHoldSkill } from './driftAndHold';
import { echoTrailGhostsSkill } from './echoTrailGhosts';
import { elementMorphHandoffSkill } from './elementMorphHandoff';
import { emphasisWordPulseSkill } from './emphasisWordPulse';
import { facetMorphShapeSkill } from './facetMorphShape';
import { feedScrollDemoSkill } from './feedScrollDemo';
import { glitchSliceTextSkill } from './glitchSliceText';
import { grainAndBloomSkill } from './grainAndBloom';
import { halftoneDotDissolveSkill } from './halftoneDotDissolve';
import { handDrawnAnnotationSkill } from './handDrawnAnnotation';
import { headlineSlamSkill } from './headlineSlam';
import { hubAndSpokesSkill } from './hubAndSpokes';
import { iconSetConsistencySkill } from './iconSetConsistency';
import { iconSwapCycleSkill } from './iconSwapCycle';
import { inlineHighlightChipSkill } from './inlineHighlightChip';
import { interfaceStateChangeSkill } from './interfaceStateChange';
import { irisRevealSkill } from './irisReveal';
import { kineticWordRevealSkill } from './kineticWordReveal';
import { knockoutSilhouetteIconSkill } from './knockoutSilhouetteIcon';
import { letterSpacingSettleSkill } from './letterSpacingSettle';
import { lightSweepPassSkill } from './lightSweepPass';
import { logoWallAssembleSkill } from './logoWallAssemble';
import { lowerThirdCalloutSkill } from './lowerThirdCallout';
import { markerEmphasisSkill } from './markerEmphasis';
import { meshGradientBackgroundSkill } from './meshGradientBackground';
import { momentSweepTransitionSkill } from './momentSweepTransition';
import { morphChainSpineSkill } from './morphChainSpine';
import { motionBlurStreakSkill } from './motionBlurStreak';
import { motionPolishSkill } from './motionPolish';
import { multiDeviceSplaySkill } from './multiDeviceSplay';
import { numberWheelRollSkill } from './numberWheelRoll';
import { objectConstructionMethodSkill } from './objectConstructionMethod';
import { orderedDitherPassSkill } from './orderedDitherPass';
import { outlineToFillTypeSkill } from './outlineToFillType';
import { panBetweenStationsSkill } from './panBetweenStations';
import { parallaxDepthDriftSkill } from './parallaxDepthDrift';
import { perspectiveMarqueeSkill } from './perspectiveMarquee';
import { pullBackRevealSkill } from './pullBackReveal';
import { quoteProofPanelSkill } from './quoteProofPanel';
import { radialSurroundSkill } from './radialSurround';
import { radialTickSystemSkill } from './radialTickSystem';
import { ratingAndProgressFillSkill } from './ratingAndProgressFill';
import { scrambleDecodeRevealSkill } from './scrambleDecodeReveal';
import { shapeMatchCutSkill } from './shapeMatchCut';
import { sharedAxisSlideSkill } from './sharedAxisSlide';
import { simulatedCursorClickSkill } from './simulatedCursorClick';
import { slatWipeRevealSkill } from './slatWipeReveal';
import { softFocusResolveSkill } from './softFocusResolve';
import { splitComparisonCardsSkill } from './splitComparisonCards';
import { splitFlapBoardSkill } from './splitFlapBoard';
import { spotlightFocusCardSkill } from './spotlightFocusCard';
import { springSettleSkill } from './springSettle';
import { staggeredListRevealSkill } from './staggeredListReveal';
import { statBarsAndFillsSkill } from './statBarsAndFills';
import { stopMotionCadenceSkill } from './stopMotionCadence';
import { streamingTextResponseSkill } from './streamingTextResponse';
import { strikethroughReplaceSkill } from './strikethroughReplace';
import { sustainedSceneRevealSkill } from './sustainedSceneReveal';
import { svgDrawOnSkill } from './svgDrawOn';
import { svgIconEnrichmentSkill } from './svgIconEnrichment';
import { textureMaskedTypeSkill } from './textureMaskedType';
import { tickerCrawlStripSkill } from './tickerCrawlStrip';
import { timelineRailAdvanceSkill } from './timelineRailAdvance';
import { typeAsObjectSkill } from './typeAsObject';
import { typewriterWithCaretSkill } from './typewriterWithCaret';
import { velocityMatchedCutSkill } from './velocityMatchedCut';
import { vignetteFocusPullSkill } from './vignetteFocusPull';
import { weightedExitSkill } from './weightedExit';
import { whipPanCutSkill } from './whipPanCut';
import { wordSwapInPlaceSkill } from './wordSwapInPlace';
import { zoomThroughTransitionSkill } from './zoomThroughTransition';

import type { CodeoSkill } from '../types';

export const HTML_DESIGN_ANIMATION_SKILLS: CodeoSkill[] = [
    objectConstructionMethodSkill,
    iconSetConsistencySkill,
    counterTickUpSkill,
    statBarsAndFillsSkill,
    dataAsMetaphorSkill,
    kineticWordRevealSkill,
    emphasisWordPulseSkill,
    markerEmphasisSkill,
    staggeredListRevealSkill,
    typeAsObjectSkill,
    svgDrawOnSkill,
    svgIconEnrichmentSkill,
    knockoutSilhouetteIconSkill,
    radialTickSystemSkill,
    ambientFloatLoopSkill,
    parallaxDepthDriftSkill,
    atmosphereGradientFieldSkill,
    ambientParticleFieldSkill,
    grainAndBloomSkill,
    motionPolishSkill,
    sustainedSceneRevealSkill,
    anchoredRelayRevealSkill,
    cinematicCameraMoveSkill,
    momentSweepTransitionSkill,
    velocityMatchedCutSkill,
    elementMorphHandoffSkill,
    morphChainSpineSkill,
    splitComparisonCardsSkill,
    cardGridAssembleSkill,
    hubAndSpokesSkill,
    logoWallAssembleSkill,
    lowerThirdCalloutSkill,
    tickerCrawlStripSkill,
    scrambleDecodeRevealSkill,
    typewriterWithCaretSkill,
    letterSpacingSettleSkill,
    softFocusResolveSkill,
    headlineSlamSkill,
    strikethroughReplaceSkill,
    irisRevealSkill,
    slatWipeRevealSkill,
    pullBackRevealSkill,
    lightSweepPassSkill,
    springSettleSkill,
    zoomThroughTransitionSkill,
    sharedAxisSlideSkill,
    handDrawnAnnotationSkill,
    calloutWithLeaderLineSkill,
    simulatedCursorClickSkill,
    deviceScreenDiveSkill,
    interfaceStateChangeSkill,
    feedScrollDemoSkill,
    numberWheelRollSkill,
    chartStoryBuildSkill,
    ratingAndProgressFillSkill,
    halftoneDotDissolveSkill,
    vignetteFocusPullSkill,
    splitFlapBoardSkill,
    textureMaskedTypeSkill,
    streamingTextResponseSkill,
    driftAndHoldSkill,
    panBetweenStationsSkill,
    echoTrailGhostsSkill,
    stopMotionCadenceSkill,
    spotlightFocusCardSkill,
    radialSurroundSkill,
    quoteProofPanelSkill,
    facetMorphShapeSkill,
    cornerBadgeStackSkill,
    meshGradientBackgroundSkill,
    whipPanCutSkill,
    glitchSliceTextSkill,
    wordSwapInPlaceSkill,
    inlineHighlightChipSkill,
    motionBlurStreakSkill,
    weightedExitSkill,
    multiDeviceSplaySkill,
    shapeMatchCutSkill,
    perspectiveMarqueeSkill,
    orderedDitherPassSkill,
    iconSwapCycleSkill,
    beatSyncAccentSkill,
    outlineToFillTypeSkill,
    timelineRailAdvanceSkill,
];
